import React, { useMemo, useReducer } from 'react';
import { useField } from 'react-final-form';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Button } from 'ksnm-common-ui/lib/Button';
import { TextAreaField } from 'ksnm-common-ui/lib/Form/TextAreaField';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';

import { controlVersionEditStore } from '@stores/dictionaryStores/controlVersionsStore/controlVersionEditStore';

import styles from './DescriptionStatus.module.scss';

export const DescriptionStatus = observer(() => {
  const [open, toggle] = useReducer((state) => !state, false);

  const { isEditMode } = controlVersionEditStore;

  const {
    meta: { submitError: textSuccessError },
  } = useField('textSuccess');

  const {
    meta: { submitError: textFailLtTError },
  } = useField('textFailLt');

  const {
    meta: { submitError: textFailGtError },
  } = useField('textFailGt');

  const {
    meta: { submitError: textFailEqError },
  } = useField('textFailEq');

  const buttonError = useMemo(
    () => textSuccessError || textFailLtTError || textFailGtError || textFailEqError,
    [textFailEqError, textFailGtError, textFailLtTError, textSuccessError],
  );

  return (
    <>
      <Button
        onClick={toggle}
        size="middle"
        className={cm(styles.button, { [styles.error]: buttonError, [styles.disabled]: !isEditMode })}
        icon={<Icon name="book" />}
      >
        <>
          Описание статусов <span className={styles.required}>*</span>
        </>
      </Button>

      {open && (
        <>
          <div className={styles.field}>
            <TextAreaField
              name="textSuccess"
              label="Описание статуса (успех)"
              disabled={!isEditMode}
              size="small"
              groupStyle={!isEditMode}
              required
              maxLength={255}
              autoSize
            />
          </div>

          <div className={styles.field}>
            <TextAreaField
              name="textFailLt"
              label="Описание статуса (расхождение +)"
              disabled={!isEditMode}
              size="small"
              groupStyle={!isEditMode}
              required
              maxLength={255}
              autoSize
            />

            <div className={styles.tooltip}>
              <Tooltip
                hideOnClick={false}
                content="Сравниваемое значение 1 (левая часть формулы) больше сравниваемого значения 2 (правая часть формулы)"
              >
                <span>
                  <Icon name="info" />
                </span>
              </Tooltip>
            </div>
          </div>

          <div className={styles.field}>
            <TextAreaField
              name="textFailGt"
              label="Описание статуса (расхождение -)"
              disabled={!isEditMode}
              size="small"
              groupStyle={!isEditMode}
              required
              maxLength={255}
              autoSize
            />

            <div className={styles.tooltip}>
              <Tooltip
                hideOnClick={false}
                content="Сравниваемое значение 1 (левая часть формулы) меньше сравниваемого значения 2 (правая часть формулы)"
              >
                <span>
                  <Icon name="info" />
                </span>
              </Tooltip>
            </div>
          </div>

          <div className={styles.field}>
            <TextAreaField
              name="textFailEq"
              label="Описание статуса (расхождение =)"
              disabled={!isEditMode}
              size="small"
              groupStyle={!isEditMode}
              required
              maxLength={255}
              autoSize
            />

            <div className={styles.tooltip}>
              <Tooltip
                hideOnClick={false}
                content="Сравниваемое значение 1 (левая часть формулы) и сравниваемое значение 2 (правая часть формулы) равны, имеет место пересортица в детализации"
              >
                <span>
                  <Icon name="info" />
                </span>
              </Tooltip>
            </div>
          </div>
        </>
      )}
    </>
  );
});
